<div class="bg-black" [class.hidden]="!isRendered">
    <router-outlet></router-outlet>
</div>
